import Crud from '../views/Discipline/Crud'
import Entity from '../views/Discipline/Add'

let routes = {
    path: '/discipline',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/discipline/add',
            name: 'NewSubject',
            component: Entity,
            meta: {
                pageTitle: 'Disciplina',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Disciplina',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/discipline/edit/:id?',
            name: 'EditSubject',
            component: Entity,
            meta: {
                pageTitle: 'Disciplina',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Disciplina',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/discipline',
            name: 'list-discipline',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Disciplinas',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Disciplinas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
